import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "small-rich-text" }
const _hoisted_2 = {
  key: 0,
  style: {"margin":"8"},
  class: "modal"
}

import RichTextField from '@/components/common/RichTextField.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RichTextFieldSmall',
  props: {
  text: { type: String, required: true, default: () => '' },
  styles: { type: String, default: () => '' },
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props;
const text = ref<string>(props.text || '');
const isActive = ref<boolean>(false);

const emit = __emit;

const change = () => {
  emit('change', text.value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      icon: "mdi-pencil-outline",
      style: _normalizeStyle(__props.styles),
      density: "compact",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = true))
    }, null, 8, ["style"]),
    (isActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_card, { title: "Edit the field" }, {
            default: _withCtx(() => [
              _createVNode(RichTextField, {
                label: "Text",
                height: 180,
                style: {"max-height":"300px"},
                modelValue: text.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
                onChange: change
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_btn, {
                class: "save-button",
                onClick: _cache[2] || (_cache[2] = 
            () => {
              isActive.value = false;
              change();
            }
          )
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Save")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})